let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8JZKd"), load("1oAGT"), load("f9Wnm")]).then(() => parcelRequire('8BsHU'));